module.exports = __webpack_public_path__ + "static/media/BoxPlotQ3_3.96f95128.svg";